export default class StringValueObject {

    /**
     * StringValueObject constructor.
     *
     * @param {string} value
     */
    constructor(value) {
        this.value = value;
    }

}